import { Lock, LockOpen } from 'lucide-react'
import React, { useState } from 'react'

import { cn } from '@/modules/shared/lib/utils'

export type InputPasswordProps = React.InputHTMLAttributes<HTMLInputElement>

const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(
	({ className, ...props }, ref) => {
		const [visiblePassword, setVisiblePassword] = useState(false)

		const handleChangeVisiblePassword = () => {
			setVisiblePassword(!visiblePassword)
		}
		return (
			<div
				className={cn(
					'flex flex-1 w-full h-12 p-1 items-center rounded-md border border-input bg-white px-3 text-md ring-offset-background focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-0',
					className,
				)}
			>
				<input
					type={visiblePassword ? 'text' : 'password'}
					{...props}
					ref={ref}
					className="w-full mr-2 placeholder:text-muted-foreground focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
				/>
				{visiblePassword ? (
					<LockOpen
						className="h-[16px] w-[16px] cursor-pointer"
						onClick={handleChangeVisiblePassword}
					/>
				) : (
					<Lock
						className="h-[16px] w-[16px] cursor-pointer"
						onClick={handleChangeVisiblePassword}
					/>
				)}
			</div>
		)
	},
)

InputPassword.displayName = 'InputPassword'

export { InputPassword }
